/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  CreateMultiDiseaseFeedbackRequest,
  HTTPValidationError,
  MultiDiseaseFeedbackResponse
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Submit feedback from the multi-disease experiment flow.

Records the member's health priorities and flow path.
 * @summary Create Feedback
 */
export const createFeedbackV1ExperimentsFeedbackPost = (
    createMultiDiseaseFeedbackRequest: CreateMultiDiseaseFeedbackRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<MultiDiseaseFeedbackResponse>(
      {url: `/v1/experiments/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMultiDiseaseFeedbackRequest, signal
    },
      );
    }
  


export const getCreateFeedbackV1ExperimentsFeedbackPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFeedbackV1ExperimentsFeedbackPost>>, TError,{data: CreateMultiDiseaseFeedbackRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFeedbackV1ExperimentsFeedbackPost>>, TError,{data: CreateMultiDiseaseFeedbackRequest}, TContext> => {

const mutationKey = ['createFeedbackV1ExperimentsFeedbackPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFeedbackV1ExperimentsFeedbackPost>>, {data: CreateMultiDiseaseFeedbackRequest}> = (props) => {
          const {data} = props ?? {};

          return  createFeedbackV1ExperimentsFeedbackPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFeedbackV1ExperimentsFeedbackPostMutationResult = NonNullable<Awaited<ReturnType<typeof createFeedbackV1ExperimentsFeedbackPost>>>
    export type CreateFeedbackV1ExperimentsFeedbackPostMutationBody = CreateMultiDiseaseFeedbackRequest
    export type CreateFeedbackV1ExperimentsFeedbackPostMutationError = HTTPValidationError

    /**
 * @summary Create Feedback
 */
export const useCreateFeedbackV1ExperimentsFeedbackPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFeedbackV1ExperimentsFeedbackPost>>, TError,{data: CreateMultiDiseaseFeedbackRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFeedbackV1ExperimentsFeedbackPost>>,
        TError,
        {data: CreateMultiDiseaseFeedbackRequest},
        TContext
      > => {

      const mutationOptions = getCreateFeedbackV1ExperimentsFeedbackPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    